import Vue from 'vue'
import App from './App.vue'
import router from './router'

import {
  BContainer, BCol, BCollapse, BImg, BImgLazy, BJumbotron, BNav,
  BNavbar, BNavbarBrand, BNavbarToggle, BNavbarNav, BNavItem, BRow
} from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLinkedin, faGithub, faTwitter, faResearchgate } from '@fortawesome/free-brands-svg-icons'
import { faHome, faScroll, faTools, faAward } from '@fortawesome/free-solid-svg-icons'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'

Vue.component('b-container', BContainer)
Vue.component('b-col', BCol)
Vue.component('b-collapse', BCollapse)
Vue.component('b-img', BImg)
Vue.component('b-img-lazy', BImgLazy)
Vue.component('b-jumbotron', BJumbotron)
Vue.component('b-nav', BNav)
Vue.component('b-navbar', BNavbar)
Vue.component('b-navbar-brand', BNavbarBrand)
Vue.component('b-navbar-nav', BNavbarNav)
Vue.component('b-navbar-toggle', BNavbarToggle)
Vue.component('b-nav-item', BNavItem)
Vue.component('b-row', BRow)

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faLinkedin, faGithub, faTwitter, faResearchgate, faHome, faScroll, faTools, faAward)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
